
import Stickyfill from 'stickyfilljs/dist/stickyfill.es6';

var elements = document.querySelectorAll('.js-sticky');
Stickyfill.add(elements);
